import { render, staticRenderFns } from "./PanoramaxPlugin.vue?vue&type=template&id=18ec89a1&scoped=true"
import script from "./PanoramaxPlugin.vue?vue&type=script&lang=ts"
export * from "./PanoramaxPlugin.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./PanoramaxPlugin.vue?vue&type=style&index=0&id=18ec89a1&prod&scoped=true&lang=less")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "18ec89a1",
  null
  ,true
)

export default component.exports